import { Session } from '@ais-ui/auth';

interface ValidateEnableMFAResponse {
  success: boolean;
}

export const validateEnableMFA = async (
  session: Session,
  userName: string,
  password: string,
  secret: string,
  totpCode: number,
): Promise<ValidateEnableMFAResponse> => {
  const response = await session.request('validateEnableMFA', {
    userName,
    password,
    secret,
    totpCode,
  });

  return response;
};
